// services/returns.service.js
import axios from 'axios';
import { GET_RETURNS_URL, GET_REASONS_URL } from '../config/config';

/**
 * Fetches returns data for the current user
 */
export const fetchReturns = async (userId) => {
  try {
    const response = await axios.get(GET_RETURNS_URL, {
      params: { UserId: userId }
    });

    if (response.data.status === 1) {
      return response.data.data;
    }
    throw new Error(response.data.message || 'Failed to fetch returns');
  } catch (error) {
    console.error('Error fetching returns data:', error);
    throw error;
  }
};

/**
 * Fetches reasons for returns
 */
export const fetchReasons = async () => {
  try {
    const response = await axios.get(GET_REASONS_URL);
    
    if (response.data.status === 1) {
      return response.data.data;
    }
    throw new Error('Failed to fetch reasons');
  } catch (error) {
    console.error('Error fetching reasons:', error);
    throw error;
  }
};